import React, { useState } from "react";

import { Button, Card, Checkbox, Col, Form, Grid, Input, message, Row, Space, theme, Typography } from "antd";
import Logo from "../../assets/png/logo.png"
import LightLogo from "../../assets/png/light-logo.png"
import { LockOutlined, MailOutlined, UserAddOutlined } from "@ant-design/icons";
import '../../style/auth.css'
import { adminLogin, } from "../../service/api";
import { useAuth } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import LoginPage from "../../assets/png/login_side.png"
import { useSecreen } from "../../context/ScreenContext";
const { Text, Title, Link } = Typography;

function Login() {
    const { login } = useAuth()
    const [isLoading, setIsLoading] = useState(false)
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const { width, height } = useSecreen()
    console.log("screenSize", width, height)

    const onFinish = async (values) => {
        setIsLoading(true)
        const body = {
            email: values.email,
            password: values.password

        }
        try {
            await adminLogin(body)
                .then((res) => {
                    console.log("login data", res)
                    if (res.status === 201) {
                        form.resetFields()
                        const fetchData = res.data.data
                        login(fetchData?.token);
                        localStorage.setItem("token", fetchData?.token);
                        setIsLoading(false);
                        navigate("/dashboard");
                    }

                }).catch((err) => {
                    setIsLoading(false);
                })
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    };

    const onFinishFeild = (value) => {
        message.error(" Field is required !")
        console.log(value)
    }

    return (
        <section className="login_section">
            <Row>
                <Col sm={24} md={24} lg={16} className="image_section">
                    <img src={LoginPage} />
                    <div className="content_section">
                        {width > 800 ? <Space>
                            {/* <img src={LightLogo} /> */}
                            <h2>Welcome  Back, Super Admin 👋
                                Sign in to access the dashboard securely.</h2>
                        </Space> :
                            <p>Welcome Back, Admin 👋
                                Sign in to access the dashboard securely. </p>}
                    </div>
                </Col>
                <Col sm={24} md={24} lg={8} className="login_form">
                    <Card actions={[<p>Need help? Contact support</p>]}>
                        <div className="login_title gradient-border">
                            <img src={Logo} />
                            <h2>Super Admin Login</h2>
                            {/* <p >
                                Welcome back to dietitian , Please enter your details below to
                                login.
                            </p> */}
                        </div>
                        <Form
                            form={form}
                            name="normal_login"
                            onFinish={onFinish}
                            onFinishFailed={onFinishFeild}
                            layout="vertical"
                        >
                            <Form.Item
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter email !"
                                    },
                                ]}
                            >
                                <Input
                                    size="large"
                                    prefix={<UserAddOutlined />}
                                    placeholder="Enter  Email"
                                />
                            </Form.Item>
                            <Form.Item
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter  your password !",
                                    },
                                ]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    type="password"
                                    placeholder="Enter Password"
                                    size="large"

                                />
                            </Form.Item>

                            <Form.Item style={{ marginBottom: "0px" }}>
                                <Button size="large" block="true" loading={isLoading} type="primary" htmlType="submit">
                                    Login
                                </Button>
                                
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </section>
    );
}

export default Login